import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';

export default function DeleteButton({ onClick }) {
    const [isDialogOpened, setIsDialogOpened] = useState(false);
    
    const handleClose = (e) => {
      e.stopPropagation();
      e.preventDefault();
      setIsDialogOpened(false);
    }

    const openDialog = (e) => {
      e.stopPropagation();
      e.preventDefault();
      setIsDialogOpened(true);
    }

    return (<>
        <DeleteIcon className="cursor-pointer" onClick={openDialog} />
        <Dialog
          open={isDialogOpened}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={onClick} color="primary" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
    </>)
}